function onKeyUpEscape(event) {
  const mediaQueryDesktop = window.matchMedia('(min-width: 1001px)');
  if (mediaQueryDesktop.matches) { 
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', 'false');
    summaryElement.focus();
  }
}

class FacetActions extends HTMLElement {
  constructor() {
    super();
    this.announcementBar = null;
    this.filterDrawerOpen = false;
    this.filterWrapper = null;
    this.headerNav = null;
  }

  connectedCallback() {
    this.announcementBar = document.getElementById('shopify-section-static-announcement');
    this.filterWrapper = document.querySelector('[data-filter-wrapper]');
    this.headerNav = document.querySelector('[data-site-header]');
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }
  
  init() {
    this.addDelegatedClickListeners();
    this.addClassOnScroll('#ProductGridContainer', '#facetActions', 'facet-actions--sticky');
  }

  addClassOnScroll(pastElementSelector, targetElementSelector, className) {
    const pastElement = document.querySelector(pastElementSelector);
    const targetElement = document.querySelector(targetElementSelector);
  
    if (!pastElement || !targetElement) {
      console.error('Element(s) not found. Check your selectors.');
      return;
    }
    window.addEventListener('scroll', () => {
      const pastElementPosition = pastElement.getBoundingClientRect().top;

      if (pastElementPosition < 0) {
        targetElement.classList.add(className);
      } else {
        targetElement.classList.remove(className);
      }
    });
  }

  addDelegatedClickListeners() { 
    document.body.addEventListener('click', (e) => {
      if (!this.isConnected || !this.filterWrapper) return;

      if (e.target.closest('[data-open-filters]')) {
        e.preventDefault();
        this.open();
        return;
      }

      if (e.target.closest('[data-close-filter-drawer]') && this.filterDrawerOpen) {
        this.close();
        return;
      }

      if (!e.target.closest('facet-filters-form') && this.filterDrawerOpen && !e.target.dataset.action) {
        this.close();
        return;
      }
    });
  }

  open() {
    this.filterDrawerOpen = true;
    this.filterWrapper.classList.add('open');
    document.body.classList.add('overlay');

    this.filterWrapper.removeAttribute('inert');
    this.filterWrapper.removeAttribute('aria-hidden');

    this.filterWrapper.querySelector('[data-close-filter-drawer]')?.focus();
  }

  close() {
    this.filterDrawerOpen = false;
    this.filterWrapper.classList.remove('open');
    document.body.classList.remove('overlay');

    this.filterWrapper.setAttribute('inert', '');
    this.filterWrapper.setAttribute('aria-hidden', 'true');
  }
}

customElements.define('facet-actions', FacetActions);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit);

    this.enhanceFacetCheckboxes();
    this.initFacetToggleFocus();

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      facetWrapper.removeEventListener('keyup', onKeyUpEscape);
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    this.sortTrigger = document.getElementById('facetsSort');
    this.sortForm = document.getElementById('facetsSortOptions');

    this.sortDropdownTrigger = document.getElementById('facetsSortByButton');
    this.sortDropdownForm = document.getElementById('facetsDropdownSortOptions');
    this.sortOptions = this.sortDropdownForm?.querySelectorAll('[role="option"]') || [];

    // Add event listeners
    this.sortTrigger.addEventListener('click', this.toggleClassOnSortForm.bind(this));
    this.sortDropdownTrigger.addEventListener('click', this.toggleClassOnSortDropdownForm.bind(this));
    this.sortDropdownTrigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggleClassOnSortDropdownForm();
      }
    });

    this.sortOptions.forEach((option, index) => {
      option.addEventListener('keydown', (e) => {
        const currentIndex = index;
        let nextIndex;
        switch (e.key) {
          case 'ArrowDown':
            e.preventDefault();
            nextIndex = (currentIndex + 1) % this.sortOptions.length;
            this.sortOptions[nextIndex].focus();
            break;
          case 'ArrowUp':
            e.preventDefault();
            nextIndex = (currentIndex - 1 + this.sortOptions.length) % this.sortOptions.length;
            this.sortOptions[nextIndex].focus();
            break;
          case 'Enter':
            e.preventDefault();
            option.click();
            break;
          case 'Escape':
            e.preventDefault();
            this.closeSortDropdown();
            this.sortDropdownTrigger.focus();
            break;
        }
      });
    });

    document.addEventListener('DOMContentLoaded', () => {
      document.body.addEventListener('click', (event) => {
        const removeFilterButton = event.target.closest('[data-remove-filter]');
        if (removeFilterButton) {
          event.preventDefault();
          this.handleRemoveFilter(removeFilterButton);
        }
      });
    });
  }

  initFacetToggleFocus() {
    const facetGroups = this.querySelectorAll('.js-filter');
  
    facetGroups.forEach((detailsEl) => {
      detailsEl.addEventListener('toggle', () => {
        if (detailsEl.open) {
          setTimeout(() => {
            const firstCheckbox = detailsEl.querySelector('.facet-checkbox input[type="checkbox"]');
            if (firstCheckbox) {
              firstCheckbox.focus();
            }
          }, 0);
        }
      });
    });
  }

  toggleClassOnFilterForm() {
    const firstFilter = document.querySelector('.facets__disclosure');
    this.filterTrigger.classList.toggle('open');
    firstFilter.setAttribute('open', '');
  }

  toggleClassOnSortForm() {
    const filterCaret = document.querySelector('#facetsSort .facet-sorting__caret');
    filterCaret.classList.toggle('open');
    this.sortTrigger.classList.toggle('open');
    this.sortForm.classList.toggle('hidden');
  }

  toggleClassOnSortDropdownForm() {
    const filterCaret = document.querySelector('#facetsSortByButton .facet-sorting__caret');
    const isOpen = this.sortDropdownForm.classList.contains('hidden-dropdown');
  
    if (isOpen) {
      this.sortDropdownForm.classList.remove('hidden-dropdown');
      this.sortDropdownForm.removeAttribute('inert');
      this.sortDropdownForm.removeAttribute('aria-hidden');
  
      this.sortDropdownForm.querySelectorAll('[role="option"]').forEach(el => {
        el.setAttribute('tabindex', '0');
      });
  
      this.sortDropdownTrigger.setAttribute('aria-expanded', 'true');
      filterCaret.classList.add('open');
  
      const selectedOption = this.sortDropdownForm.querySelector('[role="option"][aria-selected="true"]');
      selectedOption?.focus();
    } else {
      if (this.sortDropdownForm.contains(document.activeElement)) {
        document.activeElement.blur();
      }
  
      this.sortDropdownForm.classList.add('hidden-dropdown');
      this.sortDropdownForm.setAttribute('inert', '');
      this.sortDropdownForm.setAttribute('aria-hidden', 'true');
  
      this.sortDropdownForm.querySelectorAll('[role="option"]').forEach(el => {
        el.setAttribute('tabindex', '-1');
      });
  
      this.sortDropdownTrigger.setAttribute('aria-expanded', 'false');
      filterCaret.classList.remove('open');
    }
  }

  closeSortDropdown() {
    this.sortDropdownForm.classList.add('hidden-dropdown');
    this.sortDropdownForm.setAttribute('aria-hidden', 'true');
    this.sortDropdownForm.setAttribute('tabindex', '-1');
    this.sortDropdownTrigger.setAttribute('aria-expanded', 'false');
  }

  enhanceFacetCheckboxes() {
    const facetCheckboxes = this.querySelectorAll('.facet-checkbox input[type="checkbox"]');
    facetCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const input = e.target;
          if (input && !input.disabled) {
            input.checked = !input.checked;
          }
          this.onSubmitHandler(e);
        }
      });

      checkbox.addEventListener('keydown', (e) => {
        const checkboxes = Array.from(this.querySelectorAll('.facet-checkbox input[type="checkbox"]'));
        const index = checkboxes.indexOf(e.target);
      
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const next = checkboxes[index + 1] || checkboxes[0];
          next.focus();
        }
      
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = checkboxes[index - 1] || checkboxes[checkboxes.length - 1];
          prev.focus();
        }
      });
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    function reloadScriptWithCacheBuster() {
      const oldScript = document.getElementById('coreJS');

      if (!oldScript) {
        console.error('Script with ID "coreJS" not found.');
        return;
      }

      const scriptSrc = oldScript.src;
      const cacheBuster = new Date().getTime();
      const newSrc = scriptSrc.includes('?')
          ? scriptSrc.split('?')[0] + '?' + cacheBuster
          : scriptSrc + '?' + cacheBuster;

      oldScript.remove();
      const newScript = document.createElement('script');
      newScript.src = newSrc;
      newScript.id = 'coreJS';

      const dataAttributes = Array.from(oldScript.attributes).filter(attr => attr.name.startsWith('data-'));
      dataAttributes.forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
      });

      document.body.appendChild(newScript);
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
      setTimeout(reloadScriptWithCacheBuster, 750);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderCustomSorting() {
    const liElements = document.querySelectorAll('.form-field-select.list .option-decoy');
    const selectElement = document.querySelector('#SortBy');
    const selectElementSticky = document.querySelector('#SortBySticky');
    const selectValueDisplay = document.querySelector('#facetsSort');
    const selectValueDisplayState = document.querySelector('#facetsSort[data-state]');
    const selectValuelist = document.querySelector('#facetsSortOptions');
    const sortWrap = document.querySelector('.facet-filters.sorting-sticky');
    const sortCaret = document.querySelector('.facet-sorting__caret');
    const sortByValues = document.querySelectorAll('.sortby-value');
    const selectedOption = document.querySelector('.sorting-sticky .form-field-select option[selected="true"]');

    sortByValues.forEach((element) => {
      element.textContent = selectedOption ? selectedOption.textContent : '';
    });

    liElements.forEach((li, index) => {
      li.addEventListener('click', (e) => {
        const optionElements = document.querySelectorAll('select.form-field-select option');
        const optionDecoyElements = document.querySelectorAll('.form-field-select .option-decoy');          
        const optionArray = Array.from(optionElements);
        const selectedValue = optionArray[index].getAttribute('selected');
        const sortByValues = document.querySelectorAll('.sortby-value');
        const matchingOptions = document.querySelectorAll(`option[value="${e.target.getAttribute('value')}"]`);
        const matchingOptionDecoys = document.querySelectorAll(`.option-decoy[data-value="${e.target.getAttribute('value')}"]`);

        if (selectedValue === 'true' || selectedValue === 'selected') {
          return;
        }

        optionArray.forEach(option => {
          option.setAttribute('selected', 'false');
        });

        optionDecoyElements.forEach(optionDecoy => {
          optionDecoy.classList.remove('selected');
        });

        matchingOptions.forEach(option => {
          option.setAttribute('selected', 'true');
        });

        matchingOptionDecoys.forEach(optionDecoy => {
          optionDecoy.classList.add('selected');
        });

        optionArray[index].setAttribute('selected', 'true');
        selectElement.value = e.target.getAttribute('value');
        selectElementSticky.value = e.target.getAttribute('value');

        let form = document.getElementById("FacetFiltersForm");
        const formData = new FormData(form);
        let searchparams = new URLSearchParams(formData).toString();
        FacetFiltersForm.renderPage(searchparams, e);
        closeSortBy();
        document.querySelector('facet-filters-form').toggleClassOnSortDropdownForm();
        sortByValues.forEach((element) => {
          element.textContent = optionArray[index].text;
        });
      });
    });

    function closeSortBy() {
      selectValueDisplayState.setAttribute('data-state', 'closed');
      selectValuelist.classList.add('hidden');
      selectValueDisplay.classList.remove('open');
      selectValueDisplay.classList.add('closed');
      sortCaret.classList.remove('open');
    }

    function openSortBy() {
      selectValueDisplayState.setAttribute('data-state', 'open');
      selectValuelist.classList.remove('hidden');
      selectValueDisplayState.classList.add('open');
      selectValueDisplayState.classList.remove('closed');
      sortCaret.classList.add('open');
    }

    selectValueDisplay.addEventListener('click', (event) => {
      event.stopPropagation();
      if (selectValueDisplayState.getAttribute('data-state') === 'closed') {
        openSortBy();
      }
    });

    document.addEventListener('keydown', function(event) {
      event.stopPropagation();
      if ((event.key === 'Escape') && (selectValueDisplayState.getAttribute('data-state') === 'open')) {
        closeSortBy();
      }
    });

    document.addEventListener('click', function(event) {
      event.stopPropagation();
      if (selectValueDisplayState.getAttribute('data-state') === 'open' && !sortWrap.contains(event.target)) {
        closeSortBy();
      }
    });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderCustomSorting();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {

    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    document.querySelector("#remove_button_wrapper").innerHTML = parsedHTML.querySelector("#remove_button_wrapper").innerHTML;
    document.querySelector("#facet-filters-applied-wrapper").innerHTML = parsedHTML.querySelector("#facet-filters-applied-wrapper").innerHTML;
    document.querySelector("#facet-actions-applied-wrapper").innerHTML = parsedHTML.querySelector("#facet-actions-applied-wrapper").innerHTML;

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;
      const currentActiveID = document.activeElement.id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

        const newElementToActivate = document.getElementById(currentActiveID);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }

    document.querySelectorAll('facet-filters-form').forEach((form) => {
      form.enhanceFacetCheckboxes();
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
		return [
			{
				section: document.getElementById("product-grid").dataset.id,
			},
		];
	}

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  handleRemoveFilter(button) {
    const filterName = button.getAttribute('data-filter-name');
    const filterValue = button.getAttribute('data-filter-value');
    const urlParams = new URLSearchParams(window.location.search);
    const currentFilters = urlParams.getAll(filterName);
    const updatedFilters = currentFilters.filter((value) => value !== filterValue);

    urlParams.delete(filterName);
    updatedFilters.forEach((value) => urlParams.append(filterName, value));
  
    const updatedSearchParams = urlParams.toString();
    FacetFiltersForm.renderPage(updatedSearchParams);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.renderCustomSorting();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.boundCloseFilter = this.closeFilter.bind(this);
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.setAttribute('aria-label', 'Remove all filters'); 
    facetLink.setAttribute('tabindex', '0');
    facetLink.removeEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('click', this.closeFilter.bind(this));    
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'ENTER' || event.code.toUpperCase() === 'SPACE') {
        this.closeFilter(event);
      }
    });
  }

  closeFilter(event) {
    event.preventDefault();
    event.stopPropagation();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);